import React from 'react';
import { Card, CardContent } from '../ui/card';
import { cn } from '../../lib/utils';

export const KPICard = ({ 
  title, 
  value, 
  subtitle, 
  icon: Icon, 
  trend, 
  trendLabel,
  className,
  valueClassName,
  valueStyle,
  children,
  ...props 
}) => {
  const getTrendColor = () => {
    if (!trend) return '';
    if (trend > 0) return 'text-emerald-600 dark:text-emerald-400';
    if (trend < 0) return 'text-red-600 dark:text-red-400';
    return 'text-muted-foreground';
  };

  const getTrendIcon = () => {
    if (!trend) return null;
    if (trend > 0) return '↑';
    if (trend < 0) return '↓';
    return '→';
  };

  // Determine color based on valueClassName
  const getValueStyle = () => {
    if (valueClassName?.includes('emerald')) {
      return { color: '#059669' }; // emerald-600
    }
    if (valueClassName?.includes('red')) {
      return { color: '#dc2626' }; // red-600
    }
    return {};
  };

  return (
    <Card 
      className={cn(
        "border border-border bg-card hover:shadow-sm transition-all duration-200",
        className
      )}
      {...props}
    >
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div className="space-y-2 flex-1">
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <p 
              className="text-2xl font-bold tracking-tight font-mono"
              style={valueStyle || getValueStyle()}
            >
              {value}
            </p>
            {(subtitle || trend !== undefined) && (
              <div className="flex items-center gap-2 text-sm">
                {trend !== undefined && (
                  <span className={cn("font-medium", getTrendColor())}>
                    {getTrendIcon()} {Math.abs(trend)}%
                  </span>
                )}
                {trendLabel && (
                  <span className="text-muted-foreground">{trendLabel}</span>
                )}
                {subtitle && !trend && (
                  <span className="text-muted-foreground">{subtitle}</span>
                )}
              </div>
            )}
            {children}
          </div>
          {Icon && (
            <div className="p-3 rounded-lg bg-muted">
              <Icon className="h-5 w-5 text-muted-foreground" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default KPICard;
